/* eslint-disable functional/no-conditional-statement */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable functional/prefer-readonly-type */
/* eslint-disable max-lines-per-function */
/* eslint-disable sonarjs/no-gratuitous-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */

import { SetterOrUpdater } from "recoil";
import { CartAndOrder, OrderState } from "../../app/miscellaneous/orderAtom";
import { requestOrder } from "../../app/miscellaneous/requestOrder";
import { FinishLoadingInput } from "../../common-loader/hooks/useAsyncLoader";
import { definitions } from "../generated/orders-model-api";
import { ApplyPartialOrder } from "../hooks/useSubmitOrderSubset";
import { fetchPutOrder } from "./fetchPutOrder";
import { mkHcRequestError } from "./mkHcRequestError";
import { checkPostalCodeInvalid } from "./checkPostalCodeInvalid";
import { putOrderSubsetError } from "./putOrderSubsetError";

export async function putOrderSubsetPlain(
  applyPartialOrder: ApplyPartialOrder,
  order: OrderState,
  setOrder: SetterOrUpdater<OrderState>,
  successCallback?: (result: CartAndOrder) => void
): Promise<FinishLoadingInput<OrderState>> {
  const latest = await requestOrder(order);

  if (latest.order === "initializing" || latest.tag !== "successful") {
    return {
      tag: "errors",
      errors: [mkHcRequestError],
      uuid: "68d0597b-77aa-4dbf-b545-982a5a43afa0",
    };
  } else {
    const body = applyPartialOrder(latest.order);
    const result = await fetchPutOrder(body);
    sessionStorage.setItem("collectError", "true");
    if (result.tag === "successful") {
      const newestOrder = {
        //@ts-ignore
        ...(result.parsed === "initializing" ? {} : result.parsed),
      };

      if (
        result.parsed &&
        checkPostalCodeInvalid(
          result.parsed.errors as definitions["OrderError"][]
        )
      ) {
        const isInvalidPostalCode = checkPostalCodeInvalid(
          latest.order.errors as definitions["OrderError"][]
        );
        const shippingAddressError = latest.order.errors?.find((item) => {
          return item.errorGroup === "ShippingAddress";
        });

        // Flag check PUT Order is invalid postal code
        const isPutInvalidPostalCode = checkPostalCodeInvalid(
          result.parsed.errors as definitions["OrderError"][]
        );
        // Find errors is happen at Shipping Address page when PUT Order
        const putShippingAddressError = result.parsed.errors?.find((item) => {
          return item.errorGroup === "ShippingAddress";
        });

        const isShippingAddressError = !!shippingAddressError?.errorCode;

        if (
          (isInvalidPostalCode && isShippingAddressError) ||
          (isPutInvalidPostalCode && putShippingAddressError)
        ) {
          // Update the previous order shipping info (data from GET Order) when invalid postal code
          // From GET Order or PUT Order
          const newestShippingInfomation =
            (!!latest.order.shippingInformation && !isInvalidPostalCode) ||
              (!!result.parsed.shippingInformation && isPutInvalidPostalCode)
              ? latest.order.shippingInformation
              : null;

          const newestOrderErorShipAddress = {
            ...newestOrder,
            ...{
              shippingInformation: {
                shippingAddress: newestShippingInfomation?.shippingAddress,
              },
            },
          };
          setOrder(newestOrderErorShipAddress as unknown as CartAndOrder);

          // Update with shipping address data valid that send to BE before
          await fetchPutOrder(newestOrderErorShipAddress);
        } else {
          setOrder(newestOrder as unknown as CartAndOrder);

          // Update with shipping address data valid that send to BE before
          await fetchPutOrder(newestOrder);
        }
      } else {
        setOrder((_replaced) => newestOrder);

        // TODO: The code for fix issue an errorGroup still return "CustomerInformation" from PUT Order although a order
        // value data is exists a customerInformation data.
        // This snip code will consider be removed when BE fix not return "CustomerInformation" into errorGroup in case a
        // customerInformation data is fullill.
        // Ticket bug: https://dev.azure.com/digikey/Portfolio/_workitems/edit/494981
        if (
          newestOrder.errors &&
          newestOrder.errors[0] &&
          newestOrder.errors[0]?.errorGroup === "CustomerInformation" &&
          !!newestOrder.customerInformation?.email
        ) {
          const orderValue = await fetchPutOrder(newestOrder);

          orderValue.tag === "successful" &&
            setOrder((_replaced) => orderValue.parsed);
        }
      }

      successCallback?.(result.parsed);
      return { tag: "data", data: newestOrder };
    } else {
      return await putOrderSubsetError(result);
    }
  }
}
